import React, { useEffect, useState, useMemo, useCallback } from "react";
import Button from "../shared/Button/MainButton";
import styles from "./HomeProductCard.module.scss";
import HeartIcon from "../../assets/images/product-section/icon/heart.svg";
import HeartLight from "../../assets/images/product-section/icon/heartLight.svg";
import { Link } from "react-router-dom";
import HomeServices from "../../pages/home/homeService/HomeService";
import ReactLoading from "react-loading";
import { fetchFavorites } from "../../redux/Slices/FavoriteSlice";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchBasketData } from "../../redux/Slices/BasketSlice";
import BasketServices from "../basket/basketService/BasketService";
import { Modal } from "antd";
import { AxiosError } from "axios";
import InfoModalComponent from "../modalMessage/InfoModalMessage";
import ShoppingIcon from "../icon/ShoppingIcon";

interface HomeProductCardProps {
  image: string;
  title: string;
  price: number;
  discount_price: number;
  discount: string;
  buttonText: string;
  onButtonClick?: () => void;
  customStyle?: React.CSSProperties;
  discountPosition?: string;
  productId: string;
  discount_percentage?: number;
  wishlistStatus?: boolean;
  isNew?: number;
  slug: string;
}

const HomeProductCard: React.FC<HomeProductCardProps> = ({
  image,
  title,
  discount_percentage,
  price,
  discount_price,
  discount,
  buttonText,
  onButtonClick,
  customStyle,
  discountPosition,
  productId,
  wishlistStatus = false,
  isNew,
  slug,
}) => {
  const [loading, setLoading] = useState(false);
  const [wishlistStatusState, setWishlistStatusState] =
    useState<boolean>(wishlistStatus);
  const [loadingBasketAdd, setLoadingBasketAdd] = useState(false);
  useEffect(() => {
    setWishlistStatusState(wishlistStatus);
  }, [wishlistStatus]);

  const theme = useSelector((state: RootState) => state.theme.mode);
  const dispatch = useDispatch<AppDispatch>();

  const translations = useSelector(
    (state: RootState) => state.translations.data
  );

  const handleAddToWishlist = useCallback(async (id: number, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setLoading(true);

    try {
      const response = await HomeServices.addProductToWishlist({
        product_id: id,
      });
      if (response.status) {
        setWishlistStatusState(response.add_type);
        dispatch(fetchFavorites());
      } else {
        setWishlistStatusState(response.add_type);
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        InfoModalComponent({
          message: translations?.login_message,
          title: translations?.info,
          okText: translations?.okay,
          loginText: translations?.login,
        });
      } else {
        showErrorModal("Bir hata oluştu.");
      }
    } finally {
      setLoading(false);
    }
  }, [dispatch, translations]);

  const handleAddBasket = useCallback(async (id: number) => {
    setLoadingBasketAdd(true);
    try {
      await BasketServices.AddBasket({
        product_id: id,
        quantity: 1,
      });
      dispatch(fetchBasketData());
    } catch (error) {
      if (error instanceof AxiosError) {
        InfoModalComponent({
          message: translations?.login_message,
          title: translations?.info,
          okText: translations?.okay,
          loginText: translations?.login,
        });
      } else {
        showErrorModal("Bir hata oluştu.");
      }
    } finally {
      setLoadingBasketAdd(false);
    }
  }, [dispatch, translations]);
  const showErrorModal = (message: string) => {
    Modal.error({
      title: translations?.error,
      content: message,
      onOk() {},
    });
  };

  return (
    <div
      style={{
        ...customStyle,
        backgroundColor: theme === "dark" ? "rgb(58,58,58)" : " ",
      }}
      className={styles.homeProductCard}
    >
      <Link to={`/productDetail/${slug}`} key={productId}>
        <div className={styles.homeProductCardImgContainer}>
          <img
            src={image}
            alt="Home Hero"
            className={styles.homeProductCardImg}
            width={400}
            height={200}
            loading="lazy"
            decoding="async"
            style={{ aspectRatio: "400/200", objectFit: "contain" }}
          />
          {discount_percentage !== undefined && discount_percentage > 0 && (
            <div className={styles.productCardHeaderDiscount}>
              -{discount_percentage}%
            </div>
          )}

          <div
            className={styles.homeProductCardImgIcon}
            style={{
              background: wishlistStatusState ? "#de3d31" : "#fff",
            }}
            onClick={(e) => handleAddToWishlist(Number(productId), e)}
          >
            {loading ? (
              <div className={styles.loadingHeartIcon}>
                <ReactLoading
                  type={"spin"}
                  color={"#fff"}
                  height={"50%"}
                  width={"50%"}
                />
              </div>
            ) : wishlistStatusState ? (
              <img src={HeartLight} alt="Heart Icon" width={24} height={24} />
            ) : (
              <img src={HeartIcon} alt="Heart Icon" width={24} height={24} />
            )}
          </div>
        </div>
      </Link>
      <div className={styles.cardContent}>
        {isNew === 1 && (
          <p className={styles.newAndOldText}>{translations?.new}</p>
        )}
        <h2
          style={{
            color: theme === "dark" ? "#ffffff" : "#000000",
          }}
          className={styles.productTitle}
        >
          {title}
        </h2>
        <div className={styles.priceContainer}>
          {/* {discount_percentage && discount_percentage > 0 ? (
            <>
              <p className={styles.oldPrice}>{price} azn</p>
              <p className={styles.price}>{discount_price} azn</p>
            </>
          ) : (
            <p className={styles.price}>{price} azn</p>
          )} */}
          {discount_price ? (
            <>
              <p 
                className={styles.oldPrice}
                style={{ color: theme === "dark" ? "#ffffff" : "#000000" }}
              >
                {price} azn
              </p>
              <p 
                className={styles.price}
                style={{ color: theme === "dark" ? "#ffffff" : "#000000" }}
              >
                {discount_price} azn
              </p>
            </>
          ) : (
            <>
              <p className={styles.oldPrice} style={{ opacity: 0 }}>
                .
              </p>
              <p 
                className={styles.price}
                style={{ color: theme === "dark" ? "#ffffff" : "#000000" }}
              >
                {price} azn
              </p>
            </>
          )}
        </div>
        {loadingBasketAdd ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReactLoading
              type={"spin"}
              color={"#3983f0"}
              height={"10%"}
              width={"10%"}
            />
          </div>
        ) : (
          <Button
            className={
              theme === "light"
                ? styles.homeProductCardBtn
                : styles.homeProductCardBtn_dark
            }
            text={buttonText}
            icon={<ShoppingIcon />}
            onClick={() =>
              onButtonClick ? onButtonClick : handleAddBasket(Number(productId))
            }
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(HomeProductCard);
